var module = angular.module('octopusApp.projects');

module.directive('projectGroupEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/projects/views/group_editor.html'
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/project_group_editor.js
// module id = 1988117647219717
// module chunks = 1